import _ from "underts";
import filterOutCanceledAndCurrentRdvs from "./filterOutCanceledAndCurrentRdvs.js";
import findEmptyPlageBetweenTwoRdvs from "./findEmptyPlageBetweenTwoRdvs.js";
import sliceHM from "./sliceHM.js";
const emptyCases = (rdvsDeLaplage, plage, dureeMiniRdv, currentRdv) => {
    const filteredRdvs = filterOutCanceledAndCurrentRdvs(rdvsDeLaplage, currentRdv);
    const sortedRdvs = filteredRdvs.sort((rdv1, rdv2) => rdv1.hour * 60 + rdv1.minute - rdv2.hour * 60 - rdv2.minute);
    const withAddedExtremities = [
        {
            hour: plage.start.hour,
            minute: plage.start.minute,
            duration: 0,
        },
        ...sortedRdvs,
        { hour: plage.end.hour, minute: plage.end.minute, duration: 0 },
    ];
    const windows = _.windows(withAddedExtremities, 2);
    const plages = windows.map((window) => {
        return findEmptyPlageBetweenTwoRdvs(window[0], window[1]);
    });
    return plages.map((plage) => sliceHM(plage, dureeMiniRdv)).flat();
};
export default emptyCases;
//# sourceMappingURL=emptyCases.js.map